import { render } from "./Variables.vue?vue&type=template&id=0416e004"
import script from "./Variables.vue?vue&type=script&lang=ts"
export * from "./Variables.vue?vue&type=script&lang=ts"

import "./Variables.vue?vue&type=style&index=0&id=0416e004&lang=css"
script.render = render

export default script